import React, { Component } from "react";
import PopupWindow from "./PopupWindow";
import LoginButton from "./LoginButton";
import { authAPI } from "../api/api";
import { localStorageService } from "../utils/localStorageService";

import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const ToastDialog = ({ open, onClose, message }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle
        style={{ display: "flex", alignItems: "center", gap: "8px" }}
      >
        <CheckCircleIcon color="success" />
        Successful
      </DialogTitle>
      <DialogContent dividers>{message}</DialogContent>
      <DialogActions>
        <Button
          autoFocus
          onClick={onClose}
          variant="contained"
          // color="success"
          size="small"
          style={{ background: "#DF9307" }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

class PNZLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toast: false,
    };
  }

  onBtnClick = async () => {
    try {
      const accountconsent = await authAPI.accountconsent();
      const initiatecodegrant = await authAPI.initiatecodegrant(
        accountconsent.data.consentId
      );
      const redirectUri = initiatecodegrant.data.redirect;
      const left = window.screen.width / 2 - 300;
      const top = window.screen.height / 2 - 500;
      const popup = (this.popup = PopupWindow.open(
        "pnz-oauth-authorize",
        `${redirectUri}`,
        { height: 1000, width: 600, left, top }
      ));

      popup.then(
        (data) => this.onSuccess(data),
        (error) => this.onFailure(error)
      );
    } catch (error) {
      this.onFailure();
    }
  };

  onSuccess = async (data) => {
    if (!data.code) {
      return this.onFailure(new Error("'code' not found"));
    }
    try {
      const accessToken = await authAPI.accesstoken(data.code);

      this.props?.setAccessToken(accessToken.data.accessTokenObject);
      localStorageService.setAccessToken(accessToken.data.accessTokenObject);

      this.setState({ toast: true });
    } catch (error) {
      this.onFailure(error);
    }
  };

  onToastClose = () => {
    this.setState({ toast: false });
  };

  onFailure = (error) => {
    console.log(error);
  };
  render() {
    const attrs = { onClick: this.onBtnClick };
    return (
      <>
        <LoginButton at={attrs} />
        <ToastDialog
          open={this.state.toast}
          onClose={this.onToastClose}
          message="Authentication successful! Your API token is now active and will be automatically included in all your API requests."
        />
      </>
    );
  }
}

export default PNZLogin;
